module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<a class=\"link\" ko.attr.href=\"href\" ko.text=\"text\"></a>\n";
